import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface SemiDonutProps {
  datasetName: string;
  dataset: {
    labels: string[];
    data: number[];
    backgroundColor: string[];
  };
  showLegend?: boolean;
}

const SemiDonutChart: React.FC<SemiDonutProps> = ({ dataset, showLegend = true }) => {
  const { labels, data, backgroundColor } = dataset;

  const formatNumber = (num: number) => {
    return new Intl.NumberFormat().format(num);
  };

  const dataChart = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: backgroundColor,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const label = context.label || '';
            const value = context.raw || 0;
            return `${label}: ${formatNumber(value)}`;
          },
        },
      },
      legend: {
        display: showLegend,
        position: 'bottom' as const,
        align: 'center' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle' as const,
          boxWidth: 6,
          padding: 10,
        },
      },
    },
    cutout: '70%',
    rotation: -90,
    circumference: 180,
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ position: 'relative', width: '270px', height: '270px' }}>
      <Pie data={dataChart} options={options} />
    </div>
  );
};

export default SemiDonutChart;
